var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'active': _vm.handleScrollPage },attrs:{"id":"landscape-wrapper"}},[_c('div',{staticClass:"landscape-box"},[_c('Asset',{staticClass:"logo",attrs:{"name":"landscape.svg","alt":"Rotação da tela","title":"Rotação da tela"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Para prosseguir coloque seu celular na "),_c('b',[_vm._v("posição vertical")])])
}]

export { render, staticRenderFns }